export default __webpack_public_path__ + "static/media/search.756c09e8.svg";